
//needed for IE11 to work
import "core-js/stable";
import "regenerator-runtime/runtime";

const React = require('react');
const ReactDOM = require('react-dom');
const SharedModels = require('../../../shared/sharedModels');
const ReduxStore = require('./redux/reduxStore.jsx.js');
const AjaxFunctions = require('./ajaxFunctions.js');
const Provider = require('react-redux/dist/react-redux.min.js').Provider;
const BrowserRouter = require('react-router-dom').BrowserRouter;
const Utils = require('./utils.js');


import { library } from '@fortawesome/fontawesome-svg-core'
import {TopBarAndMenuV2} from './components/topBarAndMenuV2.jsx'

import {
   faEdit, faFile, faFileWord, faFileAlt, faStar as farFaStar, faArrowRight, faArrowLeft, faBell as farFaBell, faTimes as farFaTimes, faMousePointer as farFaMousePointer,
   faEye, faEyeSlash, faBoxBallot, faChevronDown, faChevronUp, faThumbsUp as farFaThumbsUp, faThumbtack as farFaThumbtack, faCommentSlash as farFaCommentSlash, faComment as farFaComment,
   faLightbulb, faEdit as farFaEdit, faFlag as farFaFlag, faArrowRight as farFaArrowRight,faArrowLeft as farFaArrowLeft, faShare as farFaShare, faCommentAltLines, faTrash as farFaTrash,
   faCopy
} from '@fortawesome/pro-regular-svg-icons'

import { faBullhorn, faTrash, faSparkles, faFire, faCoins, faStar as fasFaStar, faTimes, faHome,faUsersCog as fasFaUsersCog, faLightbulb as fasFaLightbulb, faTrophy,
   faEnvelope, faBell, faSpinner, faSeedling, faMicroscope, faCodeCommit, faQuestion as fasFaQuestion, faBars as fasFaBars, faCommentAlt, faCircle as fasFaCircle,
   faBriefcase as fasFaBriefcase, faNewspaper, faLeaf, faInfoCircle, faCog, faSignOutAlt, faFileSearch,faPlusCircle, faFolder, faFilePlus, faLocation,
   faTreasureChest, faComments, faQuestionCircle, faUser, faSearch,faEllipsisV as fasElipsisV,faThumbtack as fasFaThumbTack, faLink as fasFaLink, faBinoculars as fasFaBinoculars,
   faLayerPlus, faStickyNote, faEdit as fasFaEdit, faFlag as fasFaFlag, faConstruction as fasFaConstruction, faArrowUp as fasFaArrowUp, faThumbsUp as fasFaThumbsUp, faSortUp, faInfo,
} from '@fortawesome/pro-solid-svg-icons'

import {
   faTwitter, faLinkedinIn, faYoutube, faOrcid
} from '@fortawesome/free-brands-svg-icons'

import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { Grid } from "@material-ui/core";
import { CircleIcon } from "./components/commonControls.jsx.js";
import ConjectureCreation from './components/conjectureCreation.jsx';
import DiscussionPage from './discussionPage';

const Link = require('react-router-dom').Link;

library.add( faBullhorn, faTrash, faEdit, faFile, faFileWord, faFileAlt, faSparkles, faTrophy, faNewspaper, faFolder,faFilePlus,faLocation, faCommentAlt, faCommentAltLines,
   faFire, faCoins, farFaStar, fasFaStar, faTimes, faEye, faEyeSlash, fasFaBriefcase, faInfoCircle,faSignOutAlt,faPlusCircle,farFaBell,farFaTimes,
   faTwitter, faLinkedinIn, faEnvelope, faBell, faSpinner, faSeedling,fasFaUsersCog, fasFaLightbulb, faLeaf,faCog, faFileSearch,
   faSearch, faMicroscope, faCodeCommit, faTreasureChest, faComments, fasFaBars,faHome,fasFaCircle,fasFaLink, fasFaBinoculars,
   faQuestionCircle, faUser, faLayerPlus, faStickyNote, faBoxBallot,fasFaQuestion, faYoutube,farFaCommentSlash,farFaComment, faInfo, faOrcid,
   faChevronDown, faChevronUp, faLightbulb, farFaEdit, fasFaEdit, farFaFlag, fasFaFlag, fasFaThumbTack, farFaThumbtack, farFaShare,farFaMousePointer,
   faArrowRight, farFaArrowRight, faArrowLeft, farFaArrowLeft, fasFaConstruction, fasFaArrowUp, farFaThumbsUp, fasFaThumbsUp, faSortUp, fasElipsisV,
   farFaTrash, faCopy
);
const muiTheme = createTheme({
   typography: {
      useNextVariants: true,
      fontFamily: `"Poppins", sans-serif`,
   },
});

class IndexPage extends React.Component{
   constructor(props) {
      super(props);

      this.state = {
         allTopics: [],
         isInitialized: false,
         latestNewsPost: new SharedModels.NewsPost({}),
         headlines: [],
         amaCards: [],
      };
   }

   async componentDidMount() {
      await this.initialDataFetch(true);
   }

   async initialDataFetch() {
      let filterObject = Utils.buildFilterObject();

      try {
         AjaxFunctions.getPublicAMACards().then(cards => {
            this.setState({amaCards:cards})
         })
         AjaxFunctions.getPublicHeadlines().then(headlines => {
            this.setState({headlines:headlines})
         })
         Utils.updateCurrentUserData(true);

         AjaxFunctions.getUserPortfolios().then(portfolios => {
            ReduxStore.store.dispatch(ReduxStore.PortfolioFunctions.setPortfolioList(portfolios));
         })

         let initialData = await AjaxFunctions.initialDataFetch(filterObject);
         ReduxStore.store.dispatch(ReduxStore.CardFunctions.setUnapproved(initialData.unapprovedCards));

         let allTopics = SharedModels.formatTopicData(initialData.allTopics);
         ReduxStore.store.dispatch(ReduxStore.EditorFunctions.setAllTopics(allTopics));

         this.setState({allTopics,isInitialized: true,latestNewsPost: initialData.latestNewsPost});

         let tagTextList = [];
         for (let tag of initialData.workspaceTags) {
            tagTextList.push(tag.text)
         }
         ReduxStore.store.dispatch(ReduxStore.WorkspaceTagFunctions.setTagList(tagTextList));
         ReduxStore.store.dispatch(ReduxStore.WorkspaceTagFunctions.setFilterList(tagTextList));
         // ReduxStore.store.dispatch(ReduxStore.PortfolioFunctions.setPortfolioList(initialData.portfolios));

      }
      catch(err){
         console.log(err);
         alert('Error getting data, please try again later');
         AjaxFunctions.logClientError(err.message + '\n' + err.stack);
      }
   }

   render() {
      let isLoggedIn = window.globals.idUser != null && window.globals.idUser != '';
      let locations =
      [
         {title: "Home", validation: true, component: Link, to: '/', icon: <CircleIcon icon={['fas', "home"]} color="#4457CF" leftOffset="1" /> },
         {title: "Join Workshops", validation: true, component: Link, to: '/workshopList', icon:  <CircleIcon icon={['fas', "briefcase"]} color="#A438A5"/>},
         {title: "Discover MicroPubs™", validation: true, component: Link, to: '/listView', icon:  <CircleIcon icon={['fas', "binoculars"]} color="#FF7F2C" />},
         {title: "Create Evidence", validation: isLoggedIn, component: Link, to: '/evidenceCreation', icon: <CircleIcon icon={['fas', "plus-circle"]} color="#0BBDD1"/>},
         {title: "Create Conjectures", validation: isLoggedIn, component: Link, to: '/conjectureCreation', icon: <CircleIcon icon={['fas', "link"]} color="#4391C8"/>},
         {title: "Create Portfolios", validation: isLoggedIn, component: Link, to: '/portfolioList', icon: <CircleIcon icon={['fas', "lightbulb"]} color="#8AC25A" />},
         {title: "Messages", validation: isLoggedIn, component: Link, to: '/messages', icon:  <CircleIcon icon={['fas', "comments"]} color="#FF2F18" leftOffset="1" />},
      ]

      return(
         <Provider store={ReduxStore.store}>
            <BrowserRouter>
               <MuiThemeProvider theme={muiTheme}>
                  <TopBarAndMenuV2
                     locations={locations}
                     showAdmin={true}
                     isInitialized={true}
                     allTopics={this.state.allTopics}
                     latestNewsPost={this.state.latestNewsPost}
                     headlines={this.state.headlines}
                     amaCards={this.state.amaCards}
                  />
               </MuiThemeProvider>
            </BrowserRouter>
         </Provider>
      );
   }
}



window.onload = function() {
   ReactDOM.render(
      <IndexPage />,
      document.getElementById('reactContainer')
   );
};



